// ノベルティのproduct IDsをすべて配列にまとめる
const noveltyProductIds = ["43809623998600", "43809824571528", "43813031411848", "43813037670536"];

document.querySelectorAll(".novelty2025_button").forEach(function (button) {
  button.addEventListener("click", function () {
    const selectedProductId = this.getAttribute("data-id");
    const buttonClass = this.className;

    // まずカートを取得
    fetch("/cart.js")
      .then((response) => response.json())
      .then((cart) => {
        // カート内のノベルティ商品をすべて削除するリクエスト
        const removePromises = cart.items
          .filter((item) => noveltyProductIds.includes(String(item.id)))
          .map((item) =>
            fetch("/cart/change.js", {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify({
                id: item.key,
                quantity: 0,
              }),
            })
          );

        // 既存ノベルティ削除後に新しいノベルティを追加
        Promise.all(removePromises).then(() => {
          const formData = {
            items: [
              {
                id: parseInt(selectedProductId),
                quantity: 1,
              },
            ],
          };

          fetch("/cart/add.js", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(formData),
          })
            .then((response) => response.json())
            .then((data) => {
              console.log("Added to cart:", data);
              updateNovelties();

              // ボタンクラス保存
              this.classList.add("selectedButton");
              localStorage.setItem("selectedButtonClass", buttonClass);

              setTimeout(() => {
                window.location.href = "/cart";
              }, 500);
            })
            .catch((error) => {
              console.error("Error adding novelty:", error);
            });
        });
      })
      .catch((error) => {
        console.error("Error fetching cart:", error);
      });
  });
});

// 合計金額でノベルティ表示
function updateNovelties() {
  fetch("/cart.js")
    .then((response) => response.json())
    .then((cart) => {
      const total = cart.total_price / 100;

      console.log("Cart total:", total, "yen"); // デバッグ用

      // .novelty2025内のすべての子div（novelty1〜3）を非表示に

      $(".js_novelty2025_bnr11000").hide();
      document.querySelectorAll(".novelty2025_itemwrap > div").forEach((elNove) => {
        elNove.style.display = "none";
      });

      const noveltyThreshold = window.shippingConfig?.noveltyThreshold || 11000;
      if (total >= noveltyThreshold) {
        console.log(`Showing novelties - total >= ${noveltyThreshold}`); // デバッグ用
        // $(".novelty2025").show();
        $(".js_novelty2025_bnr11000").show();
        document.querySelectorAll(".novelty2025_itemwrap > div").forEach((elNove) => {
          elNove.style.display = "block";
        });
      } else {
        console.log(`Hiding novelties - total < ${noveltyThreshold}`); // デバッグ用
        // 合計がしきい値(11000円)未満の場合、カート内のノベルティ商品を削除
        removeNoveltyItemsFromCart(cart);
      }
    })
    .catch((error) => {
      console.error("Error fetching cart:", error);
    });
}

// カート内のノベルティ商品を削除する関数
function removeNoveltyItemsFromCart(cart) {
  // カート内のノベルティ商品を検索
  const noveltyItemsInCart = cart.items.filter((item) => noveltyProductIds.includes(String(item.id)));

  if (noveltyItemsInCart.length > 0) {
    console.log("Removing novelty items from cart - total below 11000 yen");

    // 各ノベルティ商品を削除
    const removePromises = noveltyItemsInCart.map((item) => {
      console.log(`Removing novelty item: ${item.product_title} (ID: ${item.id})`);
      return fetch("/cart/change.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          id: item.key,
          quantity: 0,
        }),
      });
    });

    // すべての削除が完了したら、カート表示を更新
    Promise.all(removePromises)
      .then(() => {
        console.log("All novelty items removed successfully");
        // 選択されたボタンのクラスもリセット
        document.querySelectorAll(".novelty2025_button").forEach((button) => {
          button.classList.remove("selectedButton");
        });
        // localStorageからも削除
        localStorage.removeItem("selectedButtonClass");

        // カート表示を強制的に更新
        refreshCartDisplay();
      })
      .catch((error) => {
        console.error("Error removing novelty items:", error);
      });
  }
}

// カート表示を強制的に更新する関数
function refreshCartDisplay() {
  // 方法1: PUB_SUB_EVENTSを使用してカート更新イベントをトリガー
  if (typeof publish !== "undefined" && typeof PUB_SUB_EVENTS !== "undefined") {
    // カート更新イベントを発行
    publish(PUB_SUB_EVENTS.cartUpdate, { source: "novelty-removal" });
  }

  // 方法2: cart-itemsのonCartUpdate()メソッドを直接呼び出し
  const cartItems = document.querySelector("cart-items");
  if (cartItems && typeof cartItems.onCartUpdate === "function") {
    cartItems.onCartUpdate();
  }

  // 方法3: ページをリロード（最後の手段）
  setTimeout(() => {
    // 上記の方法でカート表示が更新されない場合、ページをリロード
    console.log("Refreshing page to update cart display");
    window.location.reload();
  }, 1000);
}

// より確実にカート更新を待つ関数
function updateNoveltiesWithRetry(maxRetries = 3, delay = 300) {
  let retryCount = 0;

  function tryUpdate() {
    fetch("/cart.js")
      .then((response) => response.json())
      .then((cart) => {
        const total = cart.total_price / 100;

        console.log(`Retry ${retryCount + 1}: Cart total:`, total, "yen");

        $(".js_novelty2025_bnr11000").hide();
        // .novelty2025内のすべての子div（novelty1〜3）を非表示に
        document.querySelectorAll(".novelty2025_itemwrap > div").forEach((elNove) => {
          elNove.style.display = "none";
        });

        const noveltyThreshold = window.shippingConfig?.noveltyThreshold || 11000;
        if (total >= noveltyThreshold) {
          console.log(`Showing novelties - total >= ${noveltyThreshold}`);
          $(".js_novelty2025_bnr11000").show();
          document.querySelectorAll(".novelty2025_itemwrap > div").forEach((elNove) => {
            elNove.style.display = "block";
          });
        } else {
          console.log(`Hiding novelties - total < ${noveltyThreshold}`);
          // 合計がしきい値(11000円)未満の場合、カート内のノベルティ商品を削除
          removeNoveltyItemsFromCart(cart);
        }
      })
      .catch((error) => {
        console.error("Error fetching cart:", error);

        // エラーが発生した場合、リトライ
        if (retryCount < maxRetries) {
          retryCount++;
          setTimeout(tryUpdate, delay);
        }
      });
  }

  tryUpdate();
}

// カート更新イベントを監視してノベルティを更新
function setupCartUpdateListener() {
  // PUB_SUB_EVENTSとsubscribeがcart.jsで定義されているかチェック
  if (typeof PUB_SUB_EVENTS !== "undefined" && typeof subscribe !== "undefined") {
    // cart.jsのpub/subシステムを使用
    subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      console.log("Cart updated, updating novelties...");
      updateNovelties();
    });
  } else {
    // フォールバック: MutationObserverを使用してカート変更を監視
    const cartObserver = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === "childList" || mutation.type === "attributes") {
          // カート内容が変更された可能性があるのでノベルティを更新
          updateNovelties();
        }
      });
    });

    // カートアイテムコンテナを監視
    const cartItemsContainer = document.querySelector("cart-items") || document.querySelector("#main-cart-items") || document.querySelector(".cart-items");

    if (cartItemsContainer) {
      cartObserver.observe(cartItemsContainer, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ["data-quantity", "value"],
      });
    }

    // カートアイコンのバブル（数量表示）も監視
    const cartIconBubble = document.querySelector("#cart-icon-bubble") || document.querySelector(".cart-count-bubble");
    if (cartIconBubble) {
      cartObserver.observe(cartIconBubble, {
        childList: true,
        subtree: true,
        attributes: true,
      });
    }
  }

  // 数量ボタン（plus/minus）のクリックイベントを監視
  setupQuantityButtonListeners();
}

// 数量ボタン（plus/minus）のイベントリスナーを設定
function setupQuantityButtonListeners() {
  // 既存のボタンにイベントリスナーを追加
  document.querySelectorAll(".quantity__button").forEach((button) => {
    button.addEventListener("click", function () {
      // ボタンクリック後、複数回チェックしてカート更新を確実に捕捉
      setTimeout(() => updateNoveltiesWithRetry(), 100);
      setTimeout(() => updateNoveltiesWithRetry(), 500);
      setTimeout(() => updateNoveltiesWithRetry(), 1000);
    });
  });

  // 動的に追加される可能性のあるボタンに対してイベント委譲を使用
  document.addEventListener("click", function (event) {
    if (event.target.matches('.quantity__button[name="plus"], .quantity__button[name="minus"]')) {
      // ボタンクリック後、複数回チェックしてカート更新を確実に捕捉
      setTimeout(() => updateNoveltiesWithRetry(), 100);
      setTimeout(() => updateNoveltiesWithRetry(), 500);
      setTimeout(() => updateNoveltiesWithRetry(), 1000);
    }
  });

  // cart-remove-buttonのクリックイベントを監視
  document.addEventListener("click", function (event) {
    // cart-remove-button内のリンクまたはボタン自体がクリックされた場合
    if (event.target.closest("cart-remove-button") || event.target.matches("cart-remove-button") || event.target.closest('[id^="Remove-"]')) {
      console.log("Remove button clicked, updating novelties...");
      // 商品削除後、複数回チェックしてカート更新を確実に捕捉
      setTimeout(() => updateNoveltiesWithRetry(), 100);
      setTimeout(() => updateNoveltiesWithRetry(), 500);
      setTimeout(() => updateNoveltiesWithRetry(), 1000);
      setTimeout(() => updateNoveltiesWithRetry(), 1500);
    }
  });

  // 数量入力フィールドの変更も監視
  document.addEventListener("change", function (event) {
    if (event.target.matches('input.quantity__input, input[name="updates[]"], input[data-quantity-variant-id]')) {
      // 入力値変更後、複数回チェックしてカート更新を確実に捕捉
      setTimeout(() => updateNoveltiesWithRetry(), 100);
      setTimeout(() => updateNoveltiesWithRetry(), 500);
      setTimeout(() => updateNoveltiesWithRetry(), 1000);
    }
  });

  // 数量入力フィールドの入力中（input イベント）も監視
  document.addEventListener("input", function (event) {
    if (event.target.matches("input.quantity__input")) {
      // 入力中はデバウンス処理でノベルティを更新
      clearTimeout(window.quantityInputTimeout);
      window.quantityInputTimeout = setTimeout(() => {
        updateNoveltiesWithRetry();
      }, 800);
    }
  });
}

// ページ読み込み時に実行
document.addEventListener("DOMContentLoaded", function () {
  updateNovelties();
  setupCartUpdateListener();
});

// ページ表示時（ブラウザの戻るボタンなど）にも実行
window.addEventListener("pageshow", function (event) {
  updateNovelties();
});

// 202507ノベルティ
